import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoaderStore = defineStore('loader', () => {
    const isAppLoaderVisible = ref<boolean>(false)
    const appLoaderProgress = ref<number>(0) // 0 - 100
    const loadingText = ref<string>('')

    const setAppLoaderProgress = (progress: number) => {
        appLoaderProgress.value = progress
    }

    const showAppLoader = () => {
        isAppLoaderVisible.value = true
    }

    const hideAppLoader = () => {
        isAppLoaderVisible.value = false
    }

    const setLoadingText = (text: string) => {
        loadingText.value = text
    }

    return {
        isAppLoaderVisible,
        appLoaderProgress,
        loadingText,
        setLoadingText,
        showAppLoader,
        hideAppLoader,
        setAppLoaderProgress,
    }
})
